import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { IsMePipe } from './is-me.pipe';

@NgModule({
  declarations: [IsMePipe],
  imports: [CommonModule],
  exports: [IsMePipe]
})
export class IsMeModule {}
